<template>
    <div id="fb-post">
        <div class="headline ma-3 text-color bold">
            TÀI KHOẢN
        </div>
        <div class="container-tabs">
            <v-tabs
                :background-color="COLOR.BG_MAIN_COLOR"
            >
                <v-tab href="#create-process" active-class="text-color">Cài đặt</v-tab>
                <v-tab href="#activity-log"  active-class="text-color">Nhật ký hoạt động</v-tab>
                <v-tab-item value="create-process">
                    <FbPostCreateProcess />
                </v-tab-item>
                <v-tab-item value="activity-log">
                    <FbPostActivityLog />
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import FbPostCreateProcess from "~/components/user-profile/UserProfileSetting";
import FbPostActivityLog from "~/components/user-profile/UserProfileActivityLog";
import { COLOR } from "~/config/constant";
export default {
    components: {
        FbPostCreateProcess,
        FbPostActivityLog
    },
    data() {
        return {
            COLOR: COLOR
        }
    },

};
</script>
<style lang="scss">
    @import "../../scss/main";
    #fb-post {
        .v-tabs-slider-wrapper {
            color: $mainColor !important;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
    }
</style>
